export const promotionsRoutes = [
  {
    name: 'promotions',
    path: '/promotions',
    component: () => import('@/modules/promotions/views/PromotionsFeatureFlag.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  }
]
